export function calculatePlayableCards(gameState) {
    const activePlayer = gameState.getCurrentPlayer();
    const playableCards = [];

    // Loop through every card in the hand
    activePlayer.hand.forEach((card, index) => {
        let isPlayable = false;

        // Test this card against all 6 slots
        for (let slotIndex = 0; slotIndex < 6; slotIndex++) {
            if(card.isValidOn(slotIndex, gameState)) {
                isPlayable = true;
                break; // If it works on at least one slot, we can stop checking the rest!
            }
        }

        if (isPlayable) {
            playableCards.push(index);
        }
    });

    return playableCards;
}